import Checkbox, { CheckboxProps } from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Typography from "@material-ui/core/Typography";
import React, { FC } from "react";

interface Props extends CheckboxProps {
  label?: string;
}

const DPCheckbox: FC<Props> = (props) => {
  const { checked, label, style } = props;
  const mergedProps = Object.assign({ color: "primary" }, props);
  delete mergedProps.label;
  return (
    <FormControlLabel
      control={<Checkbox {...mergedProps} />}
      label={
        checked ? (
          <b>{label}</b>
        ) : (
          <Typography style={{ ...style }}>{label}</Typography>
        )
      }
    />
  );
};

export default DPCheckbox;
